import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateSnippets = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateSnippets(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['snippets']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateSnippets;
